<template>
    <b-modal size="md"
             id="currency-calculator-global"
             title="Currency Converter"
             hide-footer
             v-model="show_modal">
            <div class="col-md-12">
                <div class="item-place-bid">
                    This will calculate the landed/yen cost using the fees you would normally have when bidding.
                    <hr />
                    <div class="title-place-bid">
                        Estimated Landed Cost
                    </div>
                    <div class="form-group inline-label">
                        <label for="estimatedLandedCost">
                            {{user_currency_code}}
                            {{user_currency_sign}}
                        </label>
                        <input type="text" id="estimatedLandedCost" name="estimatedLandedCost" value=""
                               v-model="estimatedLandedCost"
                               @input="onLandedCostInput">
                    </div>
                </div>
                <div class="item-place-bid">
                    <div class="title-place-bid">
                        Bid (thousands of yen)
                    </div>
                    <div class="form-group inline-label">
                        <label for="bidPrice">JPY ¥</label>
                        <input type="text" id="bidPrice" name="bidPrice" value=""
                               v-model="bidPriceProxy" @input="onBidPriceInput">
                    </div>
                </div>
            </div>
    </b-modal>

</template>
<script>
    import {getYenFromLanded, getLandedCost} from '../util/bid_helper'
    import {mapState} from "vuex";
    export default {
        mounted(){
            let keysPressed = {};
            window.addEventListener('keydown', (e) => {
                if (!$(e.target).is(':input')) {
                    let key = e.key.toLowerCase()
                    if (key === 'c' && !e.metaKey) {
                        let currentDate = new Date();
                        let currentTime = currentDate.getTime();
                        if (keysPressed[key] && currentTime - keysPressed[key] < 500) {
                            this.show_modal = true;
                        }
                        keysPressed[key] = currentTime;
                    }
                }
            });
        },
        data(){
            return{
                show_modal: false,
                estimatedLandedCost: '',
                bidPrice: 0,
                bidPriceProxy: null,
                fees: (this.loggedInUser && this.loggedInUser.pricing_rule) ? this.loggedInUser.pricing_rule : this.defaultPricing,
            }
        },
        computed: {
            ...mapState({
                user_currency_code: state => state.currency.user_currency_code,
                user_currency_sign: state => state.currency.user_currency_sign,
            }),
        },
        methods: {
            onLandedCostInput() {
                try {
                    let yen = getYenFromLanded(this.estimatedLandedCost, this.fees, this.user_currency_code);
                    if (yen > 0) {
                        this.bidPriceProxy = yen / 1000;
                        this.bidPrice = yen;
                    } else {
                        this.bidPriceProxy = '';
                        this.bidPrice = 0;
                    }
                } catch (e) {
                    this.onFeeError(e)
                }
            },
            onBidPriceInput() {
                this.bidPrice = this.bidPriceProxy * 1000;
                try{
                    this.estimatedLandedCost = getLandedCost(this.bidPrice, this.fees, this.user_currency_code);
                } catch (e) {
                    this.onFeeError(e)
                }
            },
            onFeeError(e){
                console.warn(e)
                this.$message.error('There was a problem calculating your bid. Please refresh the page and try again.')
                this.bidPriceProxy = '';
                this.bidPrice = 0;
                this.estimatedLandedCost = ''
            },
            getSelectedItem(){
                this.currencyName = this.selectedCurrency;
                this.calculatedValue = null;
                this.putInputValue = null;
                this.getData(this.selectedCurrency);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/CurrencyCalculator.vue